import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['item', 'summary'];

  connect() {
    // 集客情報と施策履歴は Ajax で絞り込みページを描画し直さないので、送ったときに数え直す
    this.form = this.element.closest('form');
    this.refresh = this.refresh.bind(this);
    this.form?.addEventListener('submit', this.refresh);
  }

  disconnect() {
    this.form?.removeEventListener('submit', this.refresh);
  }

  refresh() {
    if (!this.hasSummaryTarget) return;

    const total = this.itemTargets.length;
    const selected = this.itemTargets.filter((item) => item.checked).length;
    this.summaryTarget.textContent = `${selected} / ${total} 店舗`;
    // 1 つも選ばずに送るとサーバは全店舗で集計する
    this.summaryTarget.hidden = selected === 0 || selected === total;
  }
}
